<template>
  <div>
    <h5>TERMOS DE USO E CONDIÇÕES GERAIS DE ASSINATURA DA GENIAL PREV</h5>
    <p><em>Última atualização: 17 de novembro de 2025</em></p>

    <p>
      A GENIAL PREV LTDA., inscrita no CNPJ sob o nº 43.877.917/0001-81, com sede na Cidade de Curitiba,
      Estado do Paraná, doravante denominada simplesmente GENIAL PREV, e o usuário (pessoa física ou jurídica)
      que contratar a licença de uso da plataforma, doravante denominado USUÁRIO ou CONTRATANTE, celebram o
      presente contrato de licença de uso de software como serviço (SaaS) e prestação de serviços acessórios,
      regido pelas cláusulas abaixo.
    </p>

    <h6>1. OBJETO</h6>

    <p>
      1.1. A GENIAL PREV concede ao USUÁRIO licença não exclusiva, intransferível, revogável e limitada de uso
      da plataforma Genial Prev, composta por:
    </p>

    <ul>
      <li>Software de cálculos previdenciários (RGPS, RPPS e regime militar);</li>
      <li>Ferramentas de gestão de clientes, importação de documentos (CNIS, CTM, CTC, PPP etc.), geração de relatórios e petições;</li>
      <li>Biblioteca de aulas gravadas e ao vivo, mapas mentais, modelos e materiais didáticos;</li>
      <li>Comunidade privada (grupos VIP) e suporte técnico-jurídico especializado.</li>
    </ul>

    <h6>2. ACEITAÇÃO DOS TERMOS</h6>

    <p>
      2.1. O acesso e uso da plataforma implicam aceitação integral e irrestrita destes Termos de Uso e da Política
      de Privacidade (disponível em <a href="https://genialprev.com.br/privacidade" target="_blank" rel="noopener noreferrer">genialprev.com.br/privacidade</a>).
    </p>
    <p>
      2.2. A GENIAL PREV poderá alterar estes Termos a qualquer tempo, notificando o USUÁRIO com antecedência mínima
      de 15 (quinze) dias por e-mail ou aviso na própria plataforma. O uso continuado após a alteração constitui
      concordância.
    </p>

    <h6>3. PLANOS, PREÇOS E PAGAMENTO</h6>

    <p>
      3.1. Os planos vigentes (mensal, anual ou vitalício) e respectivos valores estão disponíveis em
      <a href="https://app.previdenciagenial.com.br/plans" target="_blank" rel="noopener noreferrer">
        https://app.previdenciagenial.com.br/plans
      </a>.
    </p>
    <p>
      3.2. A GENIAL PREV poderá reajustar os valores anualmente pelo IGPM-FGV + 5% ou outro índice que venha a
      substituí-lo, ou ainda por alteração de escopo do serviço, sempre com comunicação prévia de 30 (trinta) dias.
    </p>
    <p>
      3.3. O pagamento será processado por intermediadores certificados PCI-DSS (ex.: Stripe, PagSeguro, Asaas).
      A GENIAL PREV não armazena dados completos de cartão de crédito.
    </p>
    <p>
      3.4. A renovação é automática. O não pagamento de qualquer parcela por mais de 7 (sete) dias implicará bloqueio
      automático do acesso até a regularização.
    </p>
    <p>
      3.5. É vedado o compartilhamento de login e senha. O uso concorrente em múltiplos dispositivos por pessoas diferentes
      será considerado violação grave, podendo acarretar cancelamento imediato da licença e cobrança de multa de 300%
      do valor anual do plano.
    </p>

    <h6>4. GARANTIA DE SATISFAÇÃO</h6>

    <p>
      4.1. O USUÁRIO tem 7 (trinta) dias corridos a contar da liberação do acesso para solicitar cancelamento com reembolso
      integral (melhor prática do mercado jurídico 2025), desde que não tenha utilizado a calculadora em mais de 5 (cinco)
      casos reais.
    </p>
    <p>
      4.2. Após esse prazo, não haverá reembolso proporcional, salvo em caso de falha grave e comprovada da plataforma.
    </p>

    <h6>5. CANCELAMENTO E RESCISÃO</h6>

    <p>
      5.1. O cancelamento deve ser solicitado por escrito ao e-mail
      <a href="mailto:contato@previdenciagenial.com.br">contato@previdenciagenial.com.br</a> ou diretamente no painel do usuário.
    </p>
    <p>
      5.2. O não pagamento não caracteriza cancelamento — apenas gera suspensão.
    </p>
    <p>5.3. A GENIAL PREV poderá rescindir imediatamente o contrato, sem reembolso, nos casos de:</p>

    <ul>
      <li>Compartilhamento de acesso;</li>
      <li>Engenharia reversa ou tentativa de cópia do software;</li>
      <li>Uso para fins ilícitos ou concorrência desleal;</li>
      <li>Violação de direitos autorais ou da LGPD.</li>
    </ul>

    <h6>6. DISPONIBILIDADE E SLA</h6>

    <p>
      6.1. A GENIAL PREV garante disponibilidade mínima de 99,5% ao mês.
    </p>
    <p>
      6.2. Manutenções programadas serão avisadas com 48h de antecedência e realizadas preferencialmente entre 00h e 05h
      (horário de Brasília).
    </p>

    <h6>7. LIMITAÇÃO DE RESPONSABILIDADE (CLÁUSULA OBRIGATÓRIA PARA CÁLCULOS)</h6>

    <p>
      7.1. O software é ferramenta auxiliar. A responsabilidade pela conferência, exatidão e aplicação jurídica dos cálculos
      é exclusivamente do advogado/usuário.
    </p>
    <p>7.2. A GENIAL PREV não se responsabiliza por:</p>

    <ul>
      <li>Erros de digitação ou interpretação do usuário;</li>
      <li>Divergências com cálculos administrativos ou judiciais;</li>
      <li>Prejuízos decorrentes de teses jurídicas rejeitadas em juízo;</li>
      <li>Perdas de prazos processuais.</li>
    </ul>

    <p>
      7.3. A responsabilidade da GENIAL PREV limita-se ao valor pago pelo USUÁRIO nos últimos 12 meses.
    </p>

    <h6>8. PROPRIEDADE INTELECTUAL</h6>

    <p>
      8.1. Todo o software, algoritmos, base de dados de índices, aulas, mapas mentais e materiais são de propriedade
      exclusiva da GENIAL PREV, protegidos pela Lei 9.610/98 (Direitos Autorais) e Lei 9.279/96 (Propriedade Industrial).
    </p>
    <p>
      8.2. É expressamente vedada a reprodução, engenharia reversa, crawling ou uso para criação de produto concorrente
      (multa contratual de R$ 2.000.000,00 + perdas e danos).
    </p>

    <h6>9. TRATAMENTO DE DADOS PESSOAIS (LGPD)</h6>

    <p>
      9.1. A GENIAL PREV atua como controladora dos dados do USUÁRIO e como operadora dos dados dos clientes finais
      inseridos na plataforma (CNIS, CTM, processos etc.).
    </p>
    <p>
      9.2. Celebraremos Acordo de Processamento de Dados (DPA) conforme art. 7º da Resolução CD/ANPD 2/2022
      (modelo disponível no login).
    </p>
    <p>
      9.3. Os dados dos clientes do USUÁRIO serão armazenados em servidores AWS Frankfurt (Europa), com criptografia
      AES-256 e backup diário.
    </p>
    <p>
      9.4. O USUÁRIO tem direito de solicitar exportação (em até 15 dias) ou exclusão definitiva de todos os dados de seus
      clientes a qualquer momento.
    </p>

    <h6>10. SUPORTE</h6>

    <p>
      10.1. Suporte técnico-jurídico disponível em horário comercial via WhatsApp VIP e e-mail, com SLA de resposta de até
      12h úteis para casos críticos.
    </p>
    <p>
      10.2. Não inclui análise de casos concretos, revisão de petições ou consultoria jurídica (serviço de mentoria pago
      à parte).
    </p>

    <h6>11. DISPOSIÇÕES FINAIS</h6>

    <p>
      11.1. Estes Termos substituem qualquer acordo verbal ou escrito anterior.
    </p>
    <p>
      11.2. A tolerância de uma parte não implica novação ou renúncia de direitos.
    </p>
    <p>
      11.3. Foro exclusivo da Comarca de Curitiba/PR, com renúncia a qualquer outro.
    </p>

    <p><strong>Encarregado de Proteção de Dados (DPO)</strong></p>

    <p>Nome: Allan Apter</p>
    <p>E-mail: <a href="mailto:contato@previdenciagenial.com.br">contato@previdenciagenial.com.br</a></p>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
